
import { isValidJSON, getInvalidJSONMessage } from '../../../../services/mini/isValidJSON';

export function cleanupTransformsJSON(str) {
    try {
        return (str || '').replace(/<thinking>.*?<\/thinking>/gis, '').replace(/<reasoning>.*?<\/reasoning>/gis, '').trim();
    } catch (error) {

    }
    return str;
}

export function formatTagsAndJSONString(str, minified) {
    let trimmed = str.trim();
    const startPattern = /<(thinking|reasoning)>[\s\S]+?<\/\1>/;
    const startMatch = trimmed.startsWith('<thinking>') || trimmed.startsWith('<reasoning>') ? trimmed.match(startPattern) : null;
    const startString = startMatch ? startMatch[0] : '';
    if (startMatch) {
        trimmed = trimmed.substring(0, startMatch.index) + trimmed.substring(startMatch.index + startMatch[0].length);
    }
    const endPattern = /<(thinking|reasoning)>[\s\S]+?<\/\1>/;
    const endMatch = trimmed.endsWith('</thinking>') || trimmed.endsWith('</reasoning>') ? trimmed.match(endPattern) : null;
    const endString = endMatch ? endMatch[0] : '';
    if (endMatch) {
        trimmed = trimmed.substring(0, endMatch.index) + trimmed.substring(endMatch.index + endMatch[0].length);
    }
    let formattedString = '';
    try {
        if (minified) {
            formattedString = JSON.stringify(JSON.parse(trimmed), null, '');
        } else {
            formattedString = JSON.stringify(JSON.parse(trimmed), null, 2);
        }
    } catch (e) {
        console.log("JSON parsing error");
    }
    if (formattedString.length < 1) {
        return str;
    } else {
        
        return [startString, formattedString, endString].filter(str => str && str.length > 0).join('\n');
    }
}

export function isTransformValueValidJSON(format, value) {
    if (format === 'json') {
        const cleanVal = cleanupTransformsJSON(value || '');
        return cleanVal ? isValidJSON(cleanVal, true) : true;
    }
    return true;
}


export function getValidationMsgForJSONFromTransform(format, value) {
    if (format === 'json') {
        const cleanVal = cleanupTransformsJSON(value || '');
        const isValid = cleanVal ? isValidJSON(cleanVal, true) : true;
        if (!isValid) {
            return getInvalidJSONMessage(null, cleanVal, true);
        }
    }
    return '';
}

